<template>
  <div class="contact">
    <v-container class="py-12 container-rewrite">
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <div>
            <span class="d-block">
              <span class="gtAmerica-bold">Reach us by email</span>
              <br />
              <a href="mailto:info@artlesscorporation.com" class="not-text-decoration color-black">info@artlesscorporation.com</a>
            </span>

            <span class="d-block mt-5">
              <span class="gtAmerica-bold">Reach us by phone</span>
              <br />
              <a href="tel:3105620916" class="not-text-decoration color-black">310-562-0916</a>
            </span>


            <div class="mt-5 width-fit-content">
              <v-dialog
                v-model="dialogWorkshop"
                max-width="85%"
                scrollable
              >
                <template v-slot:activator="{ on, attrs }">
                  
                  <v-btn class="btn-product" color="black" dark tile :ripple="false" :width="ancho" elevation="0" :height="alto" v-bind="attrs" v-on="on">

                    <span class="tag-btn-shop-now white--text">
                      Visit the <span class="bold d-block tag-btn-shop-now white--text"> workshop</span>
                    </span>
                  </v-btn>
                </template>

                <v-card color="#eeeeee">
                  <v-card-title class="text-h5 black white--text">
                    
                    Book a Tour
                    <div style="position: absolute; top: 10px; right: 10px; cursor: pointer" @click="dialogWorkshop = false;">
                      <v-icon color="white">mdi-close</v-icon>
                    </div>
                    
                    
                  </v-card-title>

                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >

                      <v-row class="my-3" justify="center" align="center" no-gutters>
                        <v-col cols="auto" class="text-center px-3">
                          <v-icon color="black">mdi-map-marker</v-icon>
                        </v-col>
                        <v-col cols="auto">
                          <span class="d-inline-block text-left">
                            <span class="d-block">
                              3011 N Main Street, Los Angeles, CA 90031
                            </span>
                            <a href="https://goo.gl/maps/s9kujdoMEoohhHy87" target="_blank" class="d-block" style="color: grey; text-decoration: none;">
                              Get directions
                            </a>
                          </span>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="name"
                            :rules="requiredRules"
                            label="Name"
                            color="grey"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="E-mail"
                            color="grey"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="phone"
                            :rules="requiredRules"
                            label="Phone"
                            color="grey"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="company"
                            :rules="requiredRules"
                            label="Company Name"
                            color="grey"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            color="grey"
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="date"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                color="grey"
                                :rules="requiredRules"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date"
                              color="grey"
                              :active-picker.sync="activePicker"
                              :min="new Date().toISOString().substr(0, 10)"
                              @change="save"
                              :allowed-dates="allowedDates"
                              @update:picker-date="pickerUpdate($event)"
                            ></v-date-picker>
                          </v-menu>

                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select
                            v-model="select"
                            :items="items"
                            label="Time"
                            required
                            color="grey"
                            :rules="requiredRules"
                          ></v-select>
                          <a href="mailto:info@artlesscorporation.com" style="color: grey !important; text-decoration: none;">Any other hours email us</a>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-textarea
                            v-model="interestedProducts"
                            label="Which Artless products are you coming to see?"
                            color="grey"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-textarea
                            v-model="anythingElse"
                            label="Please share anything that will help prepare for our meeting"
                            color="grey"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="text-center">

                          <v-btn
                            class="btn-product" color="black" dark tile :ripple="false" :width="ancho" elevation="0" :height="alto"
                            @click="validate"
                          >
                            <span class="tag-btn-shop-now white--text">
                              Book a <span class="bold tag-btn-shop-now white--text"> Tour</span>
                            </span>
                          </v-btn>
                        </v-col>
                      </v-row>

                    </v-form>
                  </v-card-text>

                </v-card>
              </v-dialog>
            </div>

            <div class="mt-5 width-fit-content">

              <v-dialog
                v-model="dialog"
                max-width="85%"
                scrollable
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="btn-product" color="black" outlined tile :ripple="false" :height="alto" :width="ancho" v-bind="attrs"
                    v-on="on">



                    <span class="tag-btn-shop-now">
                      Find a <span class="bold d-block tag-btn-shop-now"> dealer</span>
                    </span>
                  </v-btn>
                </template>

                <v-card color="#eeeeee">
                  <v-card-title class="text-h5 black white--text">
                    
                        Dealers & Reps
                    <div style="position: absolute; top: 10px; right: 10px; cursor: pointer" @click="dialog = false;">
                      <v-icon color="white">mdi-close</v-icon>
                    </div>
                    
                    
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row justify="center">

                        <v-col cols="12" md="11" xl="12">
                          <v-row justify="center" justify-sm="start">
                            <template v-for="(dealer,d) in dealers">
                              <v-col :key="'dealer-'+d" cols="8" sm="4" class="px-sm-6">
                                <a :href="dealer.link" target="_blank">
                                  <v-img :src="'https://www.artlesscms.actstudio.xyz/'+dealer.image.path" contain max-width="300px" class="mx-auto"></v-img>
                                </a>
                              </v-col>
                            </template>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <!-- <v-divider></v-divider> -->

                  <!-- <v-card-actions style="background: transparent">
                    <v-spacer></v-spacer>
                    <v-btn
                      color="black"
                      text
                      @click="dialog = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-dialog>

              
            </div>



            

            <!-- <span class="d-block mt-5 national-regular">Visit the workshop</span> -->
          </div>

          <div class="margin-div-custom">
            <!-- <a
              href="https://www.google.com/maps/place/2830+Glenoaks+Canyon+Dr,+Glendale,+CA+91206,+EE.+UU./data=!4m2!3m1!1s0x80c2c3d718be1d05:0x6d174c37298049b1?sa=X&ved=2ahUKEwiU--Tdt8vrAhURW60KHYAqAXsQ8gEwAHoECAsQAQ"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block">
                <span class="gtAmerica-bold">ARTLESS Office</span>
                <br />2830 Glenoaks Canyon Dr
                <br />Glendale CA 91206
              </span>
            </a> -->

            <a
              href="https://www.google.com/maps/place/3011+N+Main+St,+Los+Angeles,+CA+90031,+EE.+UU./@34.0662713,-118.2119496,17z/data=!3m1!4b1!4m5!3m4!1s0x80c2c679d904c3c5:0xa81f5494d34780e5!8m2!3d34.0662713!4d-118.2097609?shorturl=1"
              target="_blank"
              class="not-text-decoration"
            >
              <span class="d-block mt-5">
                <span class="gtAmerica-bold">ARTLESS</span>
                <br />3011 N Main Street
                <br />Los Angeles, CA 90031
              </span>
            </a>
          </div>

          <div class="mt-10 margin-div-mobile">
            <div
              v-for="(network, nt) in socialNetworks"
              :key="nt"
              class="d-inline-block social-separation"
            >
              <template v-if="width >= 2300">
                <template v-if="width >= 3500">
                  <a :href="network.link" target="_blank">
                    <v-img :src="network.image" width="75"></v-img>
                  </a>
                </template>
                <template v-else>  
                  <a :href="network.link" target="_blank">
                    <v-img :src="network.image" width="50"></v-img>
                  </a>
                </template>
              </template>
              <template v-else>
                <a :href="network.link" target="_blank">
                  <v-img :src="network.image"></v-img>
                </a>
              </template>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3" class="z-index-2rd-column">
          <div>
            <span class="d-block">
              <span class="d-block gtAmerica-bold">FOUNDER</span>
              <span class>
                Alejandro Artigas
                <a
                  href="mailto:artigas@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >artigas@artlesscorporation.com</a>
                <a href="tel:310-666-7529" class="d-block not-text-decoration color-black">310-666-7529</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">OPERATIONS MANAGER</span>
              <span class>
                Santiago Mazon
                <a
                  href="mailto:santiago@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >santiago@artlesscorporation.com</a>
                <a href="tel:619-252-9914" class="d-block not-text-decoration color-black">619-252-9914</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">TRADE ACCOUNTS</span>
              <span class>
                Melissa Ritchie
                <a
                  href="mailto:melissa.ritchie@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >melissa.ritchie@artlesscorporation.com</a>
                <a href="tel:323-646-2917" class="d-block not-text-decoration color-black">323-646-2917</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">DESIGN ASSOCIATE</span>
              <span class>
                Evelyn Sanchez
                <a
                  href="mailto:evelyn@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >evelyn@artlesscorporation.com</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">WEB INTEGRATION</span>
              <span class>
                Alex Bajos
                <a
                  href="mailto:bajos@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >bajos@artlesscorporation.com</a>
              </span>
            </span>

            <span class="d-block mt-10">
              <span class="d-block gtAmerica-bold">PHOTOGRAPHY</span>
              <span class>
                Melissa Keller
                <a
                  href="mailto:melissa@artlesscorporation.com"
                  class="d-block not-text-decoration color-black"
                >melissa@artlesscorporation.com</a>
              </span>
            </span>

          </div>
        </v-col>

        <v-col cols="12" sm="12" md="6" class="z-index-3rd-column">
          <v-img src="@/assets/img/photos/Artlles-profile-about.jpg" class="contact-image"></v-img>

          <div class="text-center pt-7">
            <span class="d-block title-contact">ARTLESS is after the timeless</span>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar"
      top
    >
      <span class="white--text">Thank you!</span>
    </v-snackbar>
  </div>
</template>
<script>

import VueMoment from "vue-moment";
import moment from "moment-timezone";
import instagram from "@/assets/img/icons/instagram.svg";

import pinterest from "@/assets/img/icons/pinterest.svg";

export default {
  data() {
    return {
      snackbar: false,
      dialog: false,
      dialogWorkshop: false,
      activePicker: null,
      date: null,
      menu: false,
      name: '',
      email: '',
      phone: '',
      company: '',
      date: '',
      select: '',
      interestedProducts: '',
      anythingElse: '',
      dealers: [],
      availableDates: [],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      requiredRules: [
        v => !!v || 'Required'
      ],
      socialNetworks: [
        
        {
          link: "https://www.instagram.com/artlesscorporation/",
          image: instagram,
        },
        {
          link: "https://www.pinterest.com.mx/artlesscorp/_created/",
          image: pinterest,
        },
      ],
    };
  },
  computed:{
    items: function(){
      if(this.date != ''){

        let d = moment().month(this.date.split("-")[1] - 1)
            .date(this.date.split("-")[2])
            .format("YYYY-MM-DD");
        if(moment(d).day() !== 6){
          return [
            '9:00 am',
            '9:30 am',
            '10:00 am',
            '10:30 am',
            '11:00 am',
            '11:30 am',
            '12:00 pm',
            '12:30 pm',
            '1:00 pm',
            '1:30 pm',
            '2:00 pm',
            '2:30 pm',
            '3:00 pm'
          ]
        }else{
          return [
            '9:00 am',
            '9:30 am',
            '10:00 am',
            '10:30 am',
            '11:00 am',
            '11:30 am',
            '12:00 pm'
          ]
        }
      }else{
        return [
        
        ]
      }



    },
    width:function(){
      console.log(this.$vuetify)
      return this.$vuetify.breakpoint.width;
    },
    alto: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 3500) {
          return 110;
        } else {
          return 110;
        }
      } else {
        if (this.$vuetify.breakpoint.width >= 2300) {
          return 83;
        } else {
          return 55;
        }
      }
    },
    ancho: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 2300) {
          return 368;
        } else {
          return 368;
        }
      } else {
        if (this.$vuetify.breakpoint.width >= 3500) {
          return 276;
        } else {
          return 184;
        }
      }
    },
  },
  mounted: function(){

    fetch('https://www.artlesscms.actstudio.xyz/api/collections/get/Dealers')
    .then(res => res.json())
    .then(res => this.dealers = res.entries);

    if(this.$route.name == 'VisitWorkshop'){
        this.dialog = true;
      }

    var breadcrumbs = [
        {
            text: 'Home',
            link: '/',
            isLink: true
        },
        {
            text: 'Contact',
            link: '/contact',
            isLink: false
        }
    ];
    this.$emit("updateStatus", breadcrumbs);
    this.$emit("update", 0);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Contact',
      'page_path': '/contact'
    });
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
    $route: function () {
      if(this.$route.name == 'VisitWorkshop'){
        this.dialogWorkshop = true;
      }
    }
  },
  methods: {
    validate: function (){

      if(this.$refs.form.validate()){

        fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/WorkshopTours?token=cf00a9204acb3ab54e671ca7655e5f', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                form: {
                    Name: this.name,
                    Email: this.email,
                    Phone: this.phone,
                    Company: this.company,
                    Date: this.date,
                    Hour: this.select,
                    InterestedProducts: this.interestedProducts,
                    AnythingElse: this.anythingElse
                }
            })
        })
        .then(entry => entry.json())
        .then(entry => console.log(entry))
        .then(this.snackbar = true)
        .then(this.dialogWorkshop = false)
      }

    },
    save (date) {
      this.$refs.menu.save(date)
    },
    allowedDates: function(val) {
      return this.availableDates.includes(val);
    },
    pickerUpdate: function(val){

      console.log(val)

       let totalDay = moment(val, "YYYY-MM").daysInMonth();

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) {
        day = moment().format("D");
      } else {
        day = 1;
      }

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");

        if ((moment(date).day() !== 0 )) {
          availableDates.push(date);
        }
      }

      this.availableDates = availableDates;
      this.allowedDates();
    }
  },
};
</script>